import { Injectable, Inject } from '@angular/core'
import {
  SeMembershipCardMembership,
  SeMembershipCardStatuses,
  SeMembershipCardStatus,
} from './membership-card-types'
import { SeDateTime, SeDate } from '../date-time'

@Injectable({providedIn: 'root'})
export class SeMembershipCardService {

  constructor(private seDateTime: SeDateTime ) {
    // noop
  }

  public statuses: SeMembershipCardStatuses = {
    eligible: {
      label: 'Eligible',
      color: 'green'
    },
    expired: {
      label: 'Expired',
      color: 'red'
    },
    incomplete: {
      label: 'Ineligible',
      color: 'yellow'
    },
    paid: {
      label: 'Paid',
      color: 'green'
    },
    pending: {
      label: 'Pending',
      color: 'blue'
    },
    requested: {
      label: 'Approval Needed',
      color: 'warning'
    },
    suspended: {
      label: 'Suspended',
      color: 'red'
    },
    upcoming: {
      label: 'Starts __date__',
      color: 'blue'
    }
  }

  public statusToTag(membership: SeMembershipCardMembership): SeMembershipCardStatus {
    const statusInfo = this.statuses[membership.status]
    if (!statusInfo) {
      return {
        label: membership.status,
        color: 'gray'
      }
    }
    return statusInfo
  }

  public statusLabel(membership: SeMembershipCardMembership): string {
    const status = this.statusToTag(membership) || {} as SeMembershipCardStatus
    const label = status.label
    const DATE = '__date__'

    if (label) {
      if (label.indexOf(DATE) === -1) return label
      if (membership.effectiveAt) return label.replace(DATE, this.formatDate(membership.effectiveAt))
    }

    return ''
  }

  public statusColor(membership: SeMembershipCardMembership): string {
    const status = this.statusToTag(membership)
    return status && status.color || ''
  }

  public expirationDescription(membership: SeMembershipCardMembership): string {
    return `Valid ${this.formatDate(membership.effectiveAt)} - ${this.formatDate(membership.expiresAt)}`
  }

  private formatDate(date: string): string {
    return this.seDateTime.date(date).date
  }

}
